angular.module("app").controller("ConfigurationController", [
    '$scope',
    'preloadedConfigs',
    'preloadedConfigTypes',
    'preloadedVersions',
    'configsService',
    'errorHandler',
    'logger',
    'deepCompare',
    '$window',
    '$uibModal',
    'settingsService',
    '$filter',
    '$timeout',
    'userStorage',
    'preloadedSkinsList',
    function ($scope,
              preloadedConfigs,
              preloadedConfigTypes,
              preloadedVersions,
              configsService,
              errorHandler,
              logger,
              deepCompare,
              $window,
              $modal,
              settingsService,
              $filter,
              $timeout,
              userStorage,
              preloadedSkinsList) {

        var pristineConfig = {},
            openedItemsHistory = [],
            onlyChildes = $filter("onlyChildes"),
            init,
            currentEditing = {
                menu: {}
            },
            pending;

        $scope.suggestions = {
            matches: [],
            isResultDone: false
        };
        
        $scope.settings = settingsService.getSettings();
        $scope.treeState = {
            mutated: false
        };
        $scope.updateEnableActive = function (elementScope) {
            if($scope.previous !== undefined && $scope.previous !== elementScope){
                $scope.previous && $scope.previous.enableActive && ($scope.previous.enableActive = false);
            }
            elementScope && (elementScope.enableActive = !elementScope.enableActive);
            $scope.previous = elementScope;
        };
        var listener = function (event) {
            if (event.button !== 2) {
                if($scope.previous !== undefined){
                    $scope.previous && $scope.previous.enableActive && ($scope.previous.enableActive = false);
                    $timeout(function () {
                       $scope.$apply();
                    });
                }
            }
        };
        angular.element($window).bind("click", listener);

        $scope.$on("$destroy", function (event) {
            angular.element($window).unbind("click", listener);
        });

        $scope.treeOptions = {
            showAllTreeElements: userStorage.getUserData().permissions.indexOf('viewSystemSettings') !== -1,
            canAdd:  userStorage.getUserData().permissions.indexOf('manageSystemSettings') !== -1,
            canChange: userStorage.getUserData().permissions.indexOf('manageSystemSettings') !== -1,
            canOnlySelect:  userStorage.getUserData().permissions.indexOf('manageSystemSettings') === -1,
            notSelect: userStorage.getUserData().permissions.indexOf('allowSkinsListUse') === -1 && userStorage.getUserData().permissions.indexOf('viewSystemSettings') !== -1,
            showToolsForConfiguration: userStorage.getUserData().permissions.indexOf('viewSystemSettings') !== -1 || (userStorage.getUserData().permissions.indexOf('viewSkinSettings') !== -1 && userStorage.getUserData().permissions.indexOf('manageSkinSettings') !== -1),
            showToolsForSkin: userStorage.getUserData().permissions.indexOf('viewAvailableSkinSettings') !== -1 && userStorage.getUserData().permissions.indexOf('manageAvailableSkinSettings') !== -1,
            viewSkinSettings: userStorage.getUserData().permissions.indexOf('viewSkinSettings') !== -1
        };
        $scope.menuItems = angular.copy(preloadedConfigs);
        $scope.configTypes = angular.copy(preloadedConfigTypes);
        $scope.versions = angular.copy(preloadedVersions);
        
        setCurrentVersion();
        $scope.dragControlListeners = {
            orderChanged: function (data) {
                $scope.changes = data;
                $scope.notAllowed = false;
            },
            accept: function (sourceItemHandleScope, destSortableScope) {
                return sourceItemHandleScope.sortableScope.modelValue === destSortableScope.modelValue;
            },
            dragStart: function (data) {
                initValue(data);
            },
            dragEnd: function () {
                if ($scope.changes && $scope.changes.source && $scope.changes.dest)
                    if ($scope.changes.source.index != $scope.changes.dest.index && !$scope.notAllowed) {
                        setSort($scope.changes.source.index, $scope.changes.dest.index);
                    }
            }
        };
        $scope.search = {
            query: ""
        };

        $scope.skinsList = angular.copy(preloadedSkinsList);

        function setCurrentVersion() {
            $scope.versionState = $scope.versionState || {};
            angular.forEach($scope.versions, function (version) {
                if (version.is_current == '1') {
                    return $scope.versionState.currentVersion = version;
                }
            });    
        }
        
        function selectConfigWithChildes(config, isEnabled) {
            config.is_active_for_apply = isEnabled;
            if (config.child && config.child.length) {
                for (var i = 0, length = config.child.length; i < length; i++) {
                    config.child[i].is_active_for_apply = isEnabled;
                    if (config.child[i].child && config.child[i].child.length) {
                        selectConfigWithChildes(config.child[i], isEnabled)
                    }
                }    
            }
        }
        
        $scope.selectAllConfigs = function (config, isEnabled) {
            selectConfigWithChildes(config, isEnabled);
        };

        function deleteFromMenu (menu, config) {
            for (var i = 0; i < menu.length; i++) {
                if (menu[i].id === config.id) {
                    menu.splice(i, 1);
                    return menu;
                }
                if (menu[i].child && menu[i].child.length) {
                    deleteFromMenu(menu[i].child, config)
                }
            }
            return menu
        }

        $scope.deleteConfig = function (config) {
            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmDeleteAction.html",
                controller: "ConfirmDeleteActionModalController"
            });

            modalInstance.result.then(function () {
                configsService.deleteSkinConfig({
                    config_id: config.config_id,
                    skin_id: $scope.filterOptions.skinId.id
                }).then(
                    function (response) {
                        if (response.status == "ok") {
                            logger.logSuccess("global.configDeleted");
                            // $scope.treeState.mutated = true;
                            // return $scope.resetTree();
                            setTimeout(function () {
                                $scope.$digest($scope.menuItems = deleteFromMenu($scope.menuItems, config));
                                for(var key in $scope.configData.child){
                                    if($scope.configData.child.hasOwnProperty(key) && $scope.configData.child[key] && $scope.configData.child[key].length > 0) {
                                        if($scope.configData.child[key][0].parent_id === config.config_id){
                                            $scope.configData = undefined;
                                        }
                                        break;
                                    }
                                }
                            });
                            return;
                        }
                        errorHandler(response.message);
                    },
                    function (response) {
                        errorHandler(response.message);
                    }
                )
            })
        };

        $scope.resetConfigs = function (skinId, force, updateVersions, callBack) {
            setChanges(function () {
                openedItemsHistory = [];
                currentEditing = {
                    menu: {}
                };

                $scope.suggestions = {
                    matches: []
                };

                $scope.treeState.mutated = false;

                $scope.search = {
                    query: ""
                };

                $timeout(function () {
                    $scope.$broadcast("resetConfigDirective")
                });


                pristineConfig = {};
                
                $scope.configData = undefined;

                if (updateVersions && skinId) {
                    configsService.getVersionsBySkinId(skinId).then(
                        function (response) {
                            if (response.status == "ok") {
                                $scope.versions = angular.copy(response.versions) || {};
                                setCurrentVersion();
                                callBack && callBack();
                            } else {
                                errorHandler(response.message)
                            }
                        },
                        function (response) {
                            errorHandler(response.message)
                        }
                    );
                }

            }, skinId, force);
        };

        $scope.openContent = function (menu) {
            if (!menu.limitTo) {
                menu.limitTo = menu.child.length;
                $timeout(function () {
                    $scope.$broadcast("resetConfigDirective")
                })
            }

            /* if ($scope.treeOptions.showAllTreeElements) {
             return
             }*/

            var index = openedItemsHistory.indexOf(menu);

            if (index < 0) {
                openedItemsHistory.length > 0 && closeSiblings(menu);
                openedItemsHistory.push(menu)
            } else {
                openedItemsHistory.splice(index, openedItemsHistory.length - index);
            }

            (init = function (menu) {
                $scope.allowOrder = menu.allowOrder;
                $scope.allowUpload = menu.allowUpload;
                $scope.configData = group(angular.copy(menu));
                $scope.configData ? $scope.configData.seletedID = menu.id : null;
                pristineConfig = angular.copy($scope.configData);
                currentEditing.menu = menu;
            })(menu);

        };

        $scope.submitConfigForm = function () {
            var changes = deepCompare.getChanges(pristineConfig.child, $scope.configData.child, "configSkinId");
            var groups = Object.keys(changes);
            if (!groups.length) {
                return
            } else {
                var requestData = {};
                for (var i = 0; i < groups.length; i++) {
                    for (var prop in changes[groups[i]]) {
                        requestData[changes[groups[i]][prop]["configSkinId"]] = changes[groups[i]][prop]
                    }
                }
            }
            configsService.updateConfigByConfigSkinId(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        saveDataForConfigs(requestData);
                        pristineConfig = angular.copy($scope.configData);
                        logger.logSuccess("global.updated");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        function saveDataForConfigs(savedData) {
            for (var i = 0, length = currentEditing.menu.child.length; i < length; i++) {
                if (savedData.hasOwnProperty(currentEditing.menu.child[i].configSkinId)) {
                    currentEditing.menu.child[i].value = savedData[currentEditing.menu.child[i].configSkinId].value;
                }
            }
        }

        $scope.getConfigsList = function () {
            return $scope.configData && $scope.configData.child
        };

        $scope.generateJs = function () {
            configsService.generateJs({skin_id: $scope.filterOptions.skinId.id}).then(
                function (response) {
                    if (response.status == "ok") {
                        var modalInstance;
                        logger.logSuccess("global.generated");

                        response.link && (modalInstance = $modal.open({
                            templateUrl: "views/templates/modals/openGeneratedWindow.html",
                            controller: "GenerateJsModalPageController",
                            resolve: {
                                linkToLoad: function () {
                                    return response.link
                                }
                            }
                        }));
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.addConfigGroup = function () {
            $scope.configGroup = {
                addingItem: {
                    parent_id: 0
                }
            }
        };

        $scope.revertToDefault = function () {
            init && init(currentEditing.menu);
        };

        $scope.showRevertButton = function () {
            if (!$scope.configData || !pristineConfig ||
                ((pristineConfig && !pristineConfig.child) || ($scope.configData && !$scope.configData.child))
            ) {
                return
            }
            return !!deepCompare.getChanges(pristineConfig.child, $scope.configData.child, "configSkinId")
        };

        $scope.applyConfigs = function () {
            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmApplyConfigAction.html",
                controller: "ConfirmApplyConfigModalController"
            });

            modalInstance.result.then(
                function (message) {
                    configsService.applyConfigsBySkinId({skin_id: $scope.filterOptions.skinId.id, message: message}).then(
                        function (response) {
                            if (response.status == "ok") {
                                $scope.resetConfigs($scope.filterOptions.skinId.id, true, true, function () {
                                    logger.logSuccess("global.configApplied")
                                });
                            } else {
                                errorHandler(response.message)
                            }
                        },
                        function (response) {
                            errorHandler(response.message)
                        }
                    )
                }
            );

        };

        function findInParents(keyword, arr) {
            for (var i = 0, length = arr.length; i < length; i++) {
                if (arr[i].needToShow &&
                    (((arr[i].key || '').toLowerCase().indexOf((keyword || '').toLowerCase())) != -1 ||
                    ((arr[i].description || '').toLowerCase().indexOf((keyword || '').toLowerCase())) != -1)) {
                    var temp = angular.copy(arr[i]);
                    delete temp.child;
                    $scope.suggestions.matches.push(temp);
                    continue;
                }
                if (arr[i].child && arr[i].child.length) {
                    findInParents(keyword, arr[i].child)
                }
            }
        }

        $scope.resetTree = function (force) {
            $timeout(function () {
                $scope.resetConfigs();
                $scope.showSearchResults = false;
            }, force === true ? 0 : 300);
        };

        function setChanges(cb, skinId, force) {
            if (!$scope.treeState.mutated && cb && !force) {
                return cb();
            }

            if (!$scope.filterOptions.skinId.id) {
                $scope.menuItems = {};
                return
            }

            configsService.getConfigsMenu({skin_id: $scope.filterOptions.skinId.id}).then(
                function (response) {
                    $scope.menuItems = angular.copy(response.configs);
                    cb && cb()
                },
                function (error) {
                    errorHandler(error.message);
                    return null
                }
            )
        }

        var searchQuery = "";

        $scope.searchResults = function () {
            if (!$scope.search.query) {
                searchQuery = "";
                return $scope.suggestions.matches = [];
            }
            if (($scope.search.query.length - 1) !== searchQuery.length && $scope.treeState.mutated) {
                searchQuery = $scope.search.query;
                return $scope.resetTree(true);
            }
            searchQuery = $scope.search.query;
            pending && $timeout.cancel(pending);
            pending = $timeout(function () {
                $scope.suggestions.matches = [];
                findInParents($scope.search.query, $scope.menuItems);
            }, 300);
            $scope.showSearchResults = true;
        };

        $scope.selectParent = function (config) {
            $scope.search.query = config.key;
            $scope.suggestions.matches = [];
            $scope.treeState.mutated = true;
            $scope.suggestions.isResultDone = true;
            configsService.searchConfigSkin({
                parent_id: config.parent_id,
                key: config.key,
                skin_id: $scope.filterOptions.skinId.id
            }).then(
                function (response) {
                    if (response.status == "ok") {
                        preloadedConfigs = angular.copy($scope.menuItems);
                        $scope.menuItems = angular.copy(response.configs);
                    } else {
                        errorHandler(response.error)
                    }
                },
                function (response) {
                    errorHandler(response.error)
                }
            )
        };

        $scope.revertConfigVersion = function () {
            if (!$scope.versionState.currentVersion){
                return;
            }
            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmRevertConfigAction.html",
                controller: "ConfirmRevertConfigModalController",
                resolve: {
                    preloadedData: function () {
                        return angular.copy($scope.versionState.currentVersion)
                    }
                }
            });

            modalInstance.result.then(
                function (configVersion) {
                    configsService.revertConfigVersion(configVersion.id, configVersion.message).then(
                        function (response) {
                            if (response.status == "ok") {
                                $scope.resetConfigs($scope.filterOptions.skinId.id, true, true, function () {
                                    logger.logSuccess("global.successfullyReverted")
                                });
                            } else {
                                errorHandler(response.message);
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                        }
                    )
                }
            );
        };

        function closeSiblings(menu) {
            var i = 0, orderLevel = menu.orderLevel;
            while (openedItemsHistory[i]) {
                if (openedItemsHistory[i].orderLevel == orderLevel) {
                    return openedItemsHistory.splice(i, openedItemsHistory.length - i);
                }
                i++;
            }
        }

        function group(childes) {
            var childesToShow = (!!childes && !!childes.child) ? onlyChildes(childes.child) : [],
                returnObj = {},
                i = 0;

            while (childesToShow[i]) {
                returnObj[childesToShow[i].mark || "null"] = returnObj[childesToShow[i].mark || "null"] || [];
                returnObj[childesToShow[i].mark || "null"].push(childesToShow[i]);
                i++;
            }
            if (!!childes) {
                return {child: returnObj, static: childes && childes.static}
            }
        }

        function initValue(data) {
            $scope.sourceReference = data.source.sortableScope.modelValue;
            $scope.currentOrderingArray = angular.copy(data.source.sortableScope.modelValue);
        }

        function setSort() {
            var returnArr = angular.copy($scope.sourceReference);

            setOrder(returnArr);
            for (var prop in $scope.configData.child) {
                if ($scope.sourceReference === $scope.configData.child[prop]) {
                    return $scope.configData.child[prop] = returnArr;
                }
            }
        }

        function setOrder(arr) {
            var i = 0;
            while (arr[i]) {
                arr[i].order = i + 1;
                i++;
            }
        }

        $scope.arrowDownListener = function arrowDownListener() {
            if ($scope.search.query.length && $scope.suggestions.matches.length) {
                var highlightedElements = $scope.suggestions.matches.filter(function (value) {
                    return value.isHighlighted;
                });
                if (highlightedElements.length > 0) {
                    var item = highlightedElements[0];
                    item.isHighlighted = false;
                    var index = $scope.suggestions.matches.indexOf(item);
                    if (index < $scope.suggestions.matches.length - 1) {
                        $scope.suggestions.matches[index + 1].isHighlighted = true;
                    }else {
                        $scope.suggestions.matches[0].isHighlighted = true;
                    }
                } else {
                    $scope.suggestions.matches[0].isHighlighted = true;
                }
                $timeout(function () {
                    $scope.$apply();
                })
            }
        };

        $scope.arrowUpListener = function arrowUpListener() {
            if ($scope.search.query.length && $scope.suggestions.matches.length) {
                var highlightedElements = $scope.suggestions.matches.filter(function (value) {
                    return value.isHighlighted;
                });
                if (highlightedElements.length > 0) {
                    var item = highlightedElements[0];
                    item.isHighlighted = false;
                    var index = $scope.suggestions.matches.indexOf(item);
                    if (index > 0) {
                        $scope.suggestions.matches[index - 1].isHighlighted = true;
                    }else {
                        $scope.suggestions.matches[$scope.suggestions.matches.length - 1].isHighlighted = true;
                    }
                }
                $timeout(function () {
                    $scope.$apply();
                })
            }
        }
        /**
         * Searching config selecting by enter listener
         */
        $scope.enterListener = function enterListener() {
            if ($scope.search.query.length && $scope.suggestions.matches.length) {
                var highlightedElements = $scope.suggestions.matches.filter(function (value) {
                    return value.isHighlighted;
                });
                if (highlightedElements.length > 0) {
                    $scope.selectParent(highlightedElements[0]);
                }
            }
        }
    }

])
